<template>
  <v-app>
    <AppWrapperView>
      <v-main>
        <v-container class="pa-8" fluid>
         <v-form @submit.prevent="search" ref="formRefs">
          <v-row>
            <v-col cols="12">
              <v-alert
                v-model="alertFlg"
                type="success"
                density="compact"
                :title=successMsg
                :text="$t('tanaoroshi.message.success')"
                closable
                class="ma-2"
              />
            </v-col>
          </v-row>
          <!-- 絞り込みは 店舗・棚卸日の範囲・ステータス。「検索」を押したときに反映する（2026-10-26 修正指示書 S-35・S-25） -->
          <v-row>
            <v-col cols="4">
                  <!-- 店舗が多い（約700）ので、店舗コード・店舗名を打って候補を絞り込めるようにする（2026-10-23）。
                       店舗は複数選べる。先頭の「全店舗」を選ぶと、選べる店舗すべてが対象（2026-10-24）。既定は「全店舗」（2026-10-26）。
                       auto-select-first は付けない。付けると打ち込んだときに先頭の店舗が強調され、選ばれたように見える（2026-11-01 打合せ・S-41） -->
                  <v-autocomplete
                    density="compact"
                    variant="outlined"
                    hide-details="auto"
                    v-model="searchCondition.shopCodes"
                    @update:model-value="shopSearchGuard.selected"
                    :search="shopSearch"
                    @update:search="onShopSearch"
                    :items="shopOptionsShown"
                    item-title="code_name"
                    item-value="code"
                    multiple
                    chips
                    closable-chips
                    :label="$t('tanaoroshi.label.shopCode')"
                  />
            </v-col>
            <!-- 日付はお客様の環境（ブラウザの言語）によらず日本の形（yyyy-MM-dd・日曜始まりのカレンダー）で出す。ディセントの画面と同じ DatePicker（2026-11-02 依頼） -->
            <v-col cols="3">
              <DatePicker variant="outlined" v-model="searchCondition.dateFrom" :label="$t('tanaoroshi.label.dateFrom')" />
            </v-col>
            <v-col cols="3">
              <DatePicker variant="outlined" v-model="searchCondition.dateTo" :label="$t('tanaoroshi.label.dateTo')" />
            </v-col>
            <v-col cols="2">
              <!-- 一時中断は 2026-10-26 に廃止したので選択肢に入れない（S-34） -->
              <v-select density="compact" variant="outlined" hide-details="auto"
                v-model="searchCondition.statusId" :items="statusOptions" item-title="label" item-value="id"
                clearable :label="$t('tanaoroshi.label.status')" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
                  <v-btn text @click="clear">{{ $t('common.action.clear') }}</v-btn>
                  <v-btn
                    theme="dark"
                   class="ml-4 px-8 bg-grey-darken-3"
                   elevation="2"
                   type="submit"
                   :loading="isSearching"
                   >{{ $t('common.action.search') }}</v-btn
                  >
            </v-col>
          </v-row>
          <v-row v-if="canDownloadCsvMonthly">
            <v-col cols="12" class="text-right">
              <v-btn dark class="bg-indigo-darken-1" elevation="2" @click="showDialog4Register">{{ $t('tanaoroshi.action.downloadCsvMonthly') }}</v-btn>
            </v-col>
          </v-row>
         </v-form> 
        </v-container>
        <div class="table_wrap">
          <table>
            <thead>
              <tr>
                <th v-for="header in headers" :key="header" @click.stop="tableSort(header)" :style="cursorCheck(header)">
                  {{ $t("tanaoroshi.label.table." + header) }}</th>
              </tr>
            </thead>
            <tbody v-for="(tana) in sortedTable" :key="tana.num">
              <tr v-for="(zone, idx) in tana.zoneList" :key="zone.zoneCode">
                <template v-if="idx === 0">
                  <!-- 一覧が1画面に収まるよう、店舗は「コード／名前」、日時は「日付／時刻」の2行にする（2026-10-28） -->
                  <td v-if="hasCol('shop')">
                    <div>{{ splitShop(tana.shop)[0] }}</div>
                    <div class="cell_sub">{{ splitShop(tana.shop)[1] }}</div>
                  </td>
                  <td v-if="hasCol('num')">{{ tana.num }}</td>
                  <td v-if="hasCol('tanaoroshiId')">{{ tana.tanaoroshiId }}</td>
                  <td v-if="hasCol('plannedDate')">{{ tana.plannedDate }}</td>
                  <td>
                    <div>{{ splitDateTime(tana.startDatetime)[0] }}</div>
                    <div class="cell_sub">{{ splitDateTime(tana.startDatetime)[1] }}</div>
                  </td>
                  <td>
                    <div>{{ splitDateTime(tana.endDatetime)[0] }}</div>
                    <div class="cell_sub">{{ splitDateTime(tana.endDatetime)[1] }}</div>
                  </td>
                  <td>
                    <!-- 実施中・一時中断・終了は参加リーダー一覧へのリンクにする。
                         「未完了/参加台数」は実施中・一時中断だけ併記する（終了は全台を締めるので出さない。2026-10-23） -->
                    <a v-if="isStarted(tana)" class="status_link"
                       @click.stop="moveReaderList(tana.tanaoroshiId)">
                      {{ tana.statusLabel }}<template v-if="showDeviceCount(tana)"> ({{ tana.activeDeviceCount }}/{{ tana.deviceCount }})</template>
                    </a>
                    <template v-else>{{ tana.statusLabel }}</template>
                    <div v-for="w in warnings(tana)" :key="w" class="status_warn">{{ w }}</div>
                  </td>
                  <td v-if="hasCol('inventoryModeLabel')">{{ tana.inventoryModeLabel }}</td>
                </template>
                <template v-else>
                  <td v-if="hasCol('shop')"></td>
                  <td v-if="hasCol('num')"></td>
                  <td v-if="hasCol('tanaoroshiId')"></td>
                  <td v-if="hasCol('plannedDate')"></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td v-if="hasCol('inventoryModeLabel')"></td>
                </template>
                <td>
                  <a style= "color: #1976d2;" @click="moveTanaoroshiSai(tana, zone.zoneCode)" :style="cursorCheck(null)">
                    {{ zone.zoneName }}
                  </a>
                </td>
                <td v-if="hasCol('planSuuryo')">{{ zone.planSuuryo }}</td>
                <td v-if="hasCol('readSuuryo')">{{ zone.readSuuryo }}</td>
                <td v-if="hasCol('diffSuuryo')">{{ zone.diffSuuryo }}</td>
                <td v-if="hasCol('readPrecision')">{{ zone.readPrecision }}</td>
                <td v-if="hasCol('kakuteisyaCode')">{{ idx === 0 ? tana.kakuteisyaCode : "" }}</td>
                <!-- 操作の名前（「終了取り消し」など）が切れないよう幅を取る（2026-10-26 10/24会議） -->
                <td class="action_col">
                  <template
                    v-if="
                      idx == 0 &&
                      filterActionItems(tana).length > 0
                    "
                  >
                    <v-select
                      :items="filterActionItems(tana)"
                      label=""
                      v-model="tana.actionForm"
                      item-title="label"
                      item-value="id"
                      @update:model-value="changeActionButton(tana, tana.tanaoroshiId, $event)"
                      density="compact"
                      variant="outlined"
                      solo
                      hide-details
                    />
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- ページングは他の画面と同じ作り（既定50件）。件数が多いのでサーバーで1ページ分だけ取る（2026-10-26 S-25・S-32） -->
        <v-container fluid class="pt-0 px-8">
          <v-row>
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-pagination :model-value="currentPageNo" :length="maxPageNo" :total-visible="9"
                @update:modelValue="(p) => { currentPageNo = p; reload(false); }" />
            </v-col>
            <v-col cols="3">
              <v-row>
                <v-spacer></v-spacer>
                <v-col cols="10" class="d-flex justify-end">
                  <v-select density="compact" variant="outlined" hide-details="auto" :model-value="displayPerPage"
                    :items="displayPerPageItem" item-title="name" item-value="value"
                    :label="$t('common.label.displayCountPerPage')" return-object
                    @update:modelValue="(v) => { displayPerPage = v; currentPageNo = 1; reload(false); }" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right">
                  {{ displayRange.minNo }} - {{ displayRange.maxNo }}{{ $t('common.label.displayedDataRange') }} / {{ totalCount }}{{ $t('common.label.totalCountOf') }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <TanaoroshiSessionDialog
          v-if="sessionDialogVisible"
          :dialog-data="sessionDialog"
          :handle-ok="sessionOk"
          :handle-cancel="sessionCancel"
        />
        <TanaoroshiConfirmDialog
          v-if="dialogVisible"
          :dialog-data="confirmDialog"
          :handle-ok="confirmOk"
          :handle-cancel="confirmCancel"
        />
        <ZeroData v-if="zeroDataWarningDialogFlg" :handle-ok="closeZeroDataDialog"/>
        <!-- 検索が失敗したとき。それまでは「0件」と出ていた（受入テスト後のソースレビュー C7） -->
        <MessageDialog v-if="searchErrorDialog" :dialog-data="searchErrorDialog" :handle-ok="() => (searchErrorDialog = null)" />
        <TanaoroshiResultCsvDownloadDialog v-if="registerDialogVisible" :dialog-data="registerDialog" :handle-ok="confirmRegisterOk"
          :handle-cancel="confirmRegisterCancel" />
      </v-main>
    </AppWrapperView>
  </v-app>
</template>

<script lang="js">
import Vue from "vue";
import TanaoroshiConfirmDialog from "@/components/dialog/TanaoroshiConfirmDialog";
import AppWrapperView from "@/components/views/AppWrapperView";
import api from "@/apis/staff";
import store from "@/store";
import utils from "@/utils";
import constant from "@/utils/constant";
import router from "@/router/index";
import Paths from "@/router/indexPaths";
import ZeroData from "@/components/dialog/ZeroDataDialog";
import MessageDialog from "@/components/dialog/MessageDialog";
import DatePicker from "@/components/DatePicker";
import TanaoroshiResultCsvDownloadDialog from "@/components/dialog/TanaoroshiResultCsvDownloadDialog";
import TanaoroshiSessionDialog from "@/components/dialog/TanaoroshiSessionDialog";
import { ALL_SHOPS, withAllShops, normalizeShopSelection, selectedShopCodes, limitShopOptions, createShopSearchGuard } from "@/utils/shopSelection";

// statusID定義（2026-10-15 要件定義書 第2.1版 6.3 に合わせて設計し直した）
const statusId = {
  notEnforcement: 1, // 未実施
  enforcing: 2, // 実施中
  saved: 3, // 一時中断（1日目締め）
  ended: 4, // 終了（確定するまでは取り消せる）
  confirmed: 5, // 確定（以後は変更できない）
}

// 棚卸日の範囲の開始の既定。当月1日（yyyy-MM-dd、端末の日付）（2026-11-01 打合せ・S-43）
function firstDayOfThisMonth() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-01`;
}

export default {
  components: { AppWrapperView, TanaoroshiConfirmDialog, ZeroData, MessageDialog, DatePicker, TanaoroshiResultCsvDownloadDialog, TanaoroshiSessionDialog},
  computed: {
    //ソート&日付変換後のデータ
    sortedTable() {
      let tempArray = this.tanaoroshiList.map(x => x);
      if(this.sortState.target != ""){
        //昇順
        if(this.sortState.ascent) tempArray = tempArray.sort((a, b) => {
          if(a[this.sortState.target] > b[this.sortState.target]){
            return 1;
          }
          if(a[this.sortState.target] < b[this.sortState.target]){
            return -1;
          }
          return 0;
        })
        //降順
        else tempArray = tempArray.sort((a, b) => {
          if(a[this.sortState.target] > b[this.sortState.target]){
            return -1;
          }
          if(a[this.sortState.target] < b[this.sortState.target]){
            return 1;
          }
          return 0;
        })
      }
      // 並べ替えを選んでいなければ API の並び（店番号順→棚卸日の新しい順→棚卸IDの大きい順。2026-10-30 受入テスト #15）。
      // 見出しでの並べ替えは、表示しているページの中だけ

      // 変換
      tempArray = tempArray.map((x, index) => {
        // noはなし
        // x.no = index + 1;
        
        //確定されていない場合は確定者コードを空文字にする
        if(x.statusId < statusId.confirmed) x.kakuteisyaCode = "";
        
        x.startDatetime = utils.putSplitWordToCalendarWithTime(x.startDatetime);
        x.plannedDate = utils.putSplitWordToCalendar(x.plannedDate);
        x.endDatetime = utils.putSplitWordToCalendarWithTime(x.endDatetime);
        x.showActionButton = utils.StringToBool(x.showActionButton);
        x.isStartedKakutei = utils.StringToBool(x.isStartedKakutei);
        return x;
      })

      return tempArray;
    },
    // ヘッダー
    headers() {
      return this.$getTableDef("TanaoroshiPage");
    },
    // 店舗の候補（先頭に「全店舗」。2026-10-24）
    shopOptions() {
      return withAllShops(this.shopItem, this.$t('common.label.allShops'));
    },
    // 欄に渡す候補（打った文字に当たる先頭100件＋全店舗＋選択済み。2026-10-26 S-32）
    shopOptionsShown() {
      return limitShopOptions(this.shopOptions, this.shopSearch, this.searchCondition.shopCodes);
    },
    // ステータスの絞り込みの選択肢。一時中断は廃止したので入れない（2026-10-26 S-34・S-35）
    statusOptions() {
      return [statusId.notEnforcement, statusId.enforcing, statusId.ended, statusId.confirmed]
        .map((id) => ({ id, label: this.$t('tanaoroshi.label.statusOption.' + id) }));
    },
    // ページ数（サーバーが返す全件数から）
    maxPageNo() {
      return Math.max(1, Math.ceil(this.totalCount / this.displayPerPage.value));
    },
    // 「x - y件目」の表示
    displayRange() {
      if (this.totalCount === 0) return { minNo: 0, maxNo: 0 };
      const minNo = (this.currentPageNo - 1) * this.displayPerPage.value + 1;
      return { minNo, maxNo: Math.min(this.totalCount, this.currentPageNo * this.displayPerPage.value) };
    },
  },

  watch: {
    // 「全店舗」と個別の店舗を同時に選ばないよう直す（2026-10-24）。
    // 店舗を選んだだけでは検索しない。他の画面と同じく「検索」で出し直す（2026-10-26 10/24会議）
    "searchCondition.shopCodes"(value, oldValue) {
      const fixed = normalizeShopSelection(value, oldValue);
      if (fixed !== value) this.searchCondition.shopCodes = fixed;
    },
  },

  data() {
    return {
    // アクション選択肢定義
      actionButtonKakutei: { id: 2, label: this.$t('tanaoroshi.action.actionButtonKakutei') },
      actionButtonRenkei: { id: 3, label: this.$t('tanaoroshi.action.actionButtonRenkei') },
      actionButtonDownloadCsv: { id: 4, label: this.$t('tanaoroshi.action.actionButtonDownloadCsv') },
      actionButtonClear: {id: 0, label: this.$t('tanaoroshi.action.actionButtonClear')},
      // 棚卸の状態の操作（id は API の action）。一時中断は廃止（CR-002 S-34）。廃止前に一時中断した棚卸には「再開」だけ出す
      sessionActions: {
        RESUME: { id: "RESUME", label: this.$t('tanaoroshiSessionDialog.action.RESUME') },
        END: { id: "END", label: this.$t('tanaoroshiSessionDialog.action.END') },
        CANCEL_END: { id: "CANCEL_END", label: this.$t('tanaoroshiSessionDialog.action.CANCEL_END') },
        CONFIRM: { id: "CONFIRM", label: this.$t('tanaoroshiSessionDialog.action.CONFIRM') },
        CANCEL_CONFIRM: { id: "CANCEL_CONFIRM", label: this.$t('tanaoroshiSessionDialog.action.CANCEL_CONFIRM') },
        DELETE: { id: "DELETE", label: this.$t('tanaoroshiSessionDialog.action.DELETE') },
      },
      sessionDialogVisible: false,
      sessionDialog: { action: null, tanaoroshi: {} },
      shopItem: [],
      // 入力中の検索条件と、「検索」で反映した条件（ページ送りは反映した条件で行う）
      searchCondition: {
        shopCodes: [ALL_SHOPS], // 店舗コード（複数。「全店舗」は ALL_SHOPS。既定は全店舗。2026-10-24・10-26）
        dateFrom: firstDayOfThisMonth(), // 棚卸日の範囲（yyyy-MM-dd。2026-10-26 S-35）。開始の既定は当月1日（2026-11-01 打合せ・S-43）
        dateTo: "",
        statusId: null,         // ステータス（null は指定なし）
      },
      appliedCondition: null,
      // 店舗の欄に打っている文字（候補の絞り込み用）
      shopSearch: "",
      // 店舗を選んだ直後に打った文字が消えないようにする（createShopSearchGuard）
      shopSearchGuard: createShopSearchGuard(),
      // ページング（サーバーで1ページ分だけ取る。既定50件。2026-10-26 S-25）
      currentPageNo: 1,
      displayPerPage: utils.getDisplayPerPage(this.$t),
      displayPerPageItem: utils.getDisplayPerPageItem(this.$t, false),
      totalCount: 0,
      // 検索の通し番号（後から返ってきた古い検索結果で上書きしないため）
      searchSeq: 0,

      dialogVisible: false,
      confirmDialog: {
        actionType: 0,
        tanaoroshi: {},
      },

      tanaoroshiList: [],
      
      sortState: {target: "", ascent: true},

      alertFlg: false,
      successMsg: "",

      currentConfirmId: null,

      // 0件取得時の警告ダイアログ
      zeroDataWarningDialogFlg: false,
      // 検索の失敗を知らせるダイアログ { message, errorList }。null なら出さない
      searchErrorDialog: null,
      // 検索中
      isSearching: false,

      // タイムアウトのID
      timeoutId: null,
      // 登録ダイアログ表示フラグ
      registerDialogVisible: false,
      // ユーザ登録ダイアログに渡すデータ
      registerDialog: {
      },
      canDownloadCsvMonthly: false,
    };
  },
  methods: {
    // 店舗欄の打った文字。店舗を選んだ直後に Vuetify が消すのは受け付けない（createShopSearchGuard）
    onShopSearch(value) {
      if (this.shopSearchGuard.accepts(value)) this.shopSearch = value;
    },
    //カーソルの変更
    cursorCheck(value) {
      if(!(value == "shop" || value == "num" || value == "tanaoroshiId" || value == "startDatetime" || value == "endDatetime" || value == "statusLabel" || value == null)) return "cursor: not-allowed;";
      else return "cursor: pointer;"
    },

    // 列設定（plugins/setting/table/<company>.json）に含まれる列だけ描画する。
    // thead は headers を回しているので、tbody も同じ判定に揃えないと列がずれる。
    hasCol(name) {
      return this.headers.includes(name);
    },

    // 店舗でいちばん新しい棚卸か（棚卸日が最も新しいもの。同じ日なら棚卸IDの大きいもの）。
    // 確定解除は最新の棚卸にしか行わない運用なので、古い棚卸には出さない（2026-10-23）。
    // ページングで同じ店舗の最新が別のページにあることがあるので、サーバーの判定（latestInShop）を使う（2026-10-26）
    isLatestInShop(tanaRow) {
      return tanaRow.latestInShop === true;
    },

    // 一覧の「店舗」列に出す文字（店舗コード_店舗名）
    // 「46329_京都ファミリー」を店舗コードと店舗名に分ける（一覧で2行に出す）
    splitShop(shop) {
      const s = shop ?? "";
      const i = s.indexOf("_");
      return i < 0 ? [s, ""] : [s.slice(0, i), s.slice(i + 1)];
    },

    // 「2026-10-28 12:50:41」を日付と時刻に分ける（一覧で2行に出す）
    splitDateTime(value) {
      const [date, time] = (value ?? "").split(" ");
      return [date ?? "", time ?? ""];
    },

    shopLabel(siteCode) {
      return this.shopItem.find((e) => e.code === siteCode)?.code_name ?? siteCode ?? "";
    },

    // 「未完了/参加台数」を併記するか。終了は全台を締めるので出さない（2026-10-23）
    showDeviceCount(tanaoroshi) {
      return tanaoroshi.statusId != statusId.ended;
    },

    // 2:実施中 のときだけ稼働台数を併記してリンクにする
    isStarted(tanaoroshi) {
      return [statusId.enforcing, statusId.saved, statusId.ended].includes(tanaoroshi.statusId)
        && tanaoroshi.deviceCount != null && tanaoroshi.deviceCount > 0;
    },

    // 状態の横に出す警告
    warnings(tana) {
      const list = [];
      if ((tana.statusId == statusId.saved || tana.statusId == statusId.ended) && tana.notDoneReaderCount > 0) {
        list.push(this.$t('tanaoroshi.message.warnNotDone', { count: tana.notDoneReaderCount }));
      }
      // 「出し直してください」は実施中には出さない（2026-10-28）。DAT は終了しないと出し直せず、
      // 1日目に出力して2日目に終了取消で読むと毎回出てしまうため。終了したときに残っていれば出す
      const canReoutput = tana.statusId != statusId.enforcing;
      if (canReoutput && tana.receivedAfterDatOutput) {
        list.push(this.$t('tanaoroshi.message.warnReceivedAfterDat'));
      }
      if (canReoutput && tana.dateChangedAfterDatOutput) {
        list.push(this.$t('tanaoroshi.message.warnDateChangedAfterDat'));
      }
      if (tana.lateEpcCount > 0) {
        list.push(this.$t('tanaoroshi.message.warnLate', { count: tana.lateEpcCount }));
      }
      return list;
    },

    sessionOk() {
      this.sessionDialogVisible = false;
      this.clearActionFormValue();
      this.reload();
    },
    sessionCancel() {
      this.sessionDialogVisible = false;
      this.clearActionFormValue();
    },

    moveReaderList(tanaoroshiId) {
      this.$router.push({ name: Paths.TANAOROSHI_READER, params: { id: tanaoroshiId } });
    },

    moveTanaoroshiSai(tanaoroshi, zoneCode) {
      // 理論在庫:APV在庫の全体以外のゾーンコードの場合は棚卸差異画面へ移行しない。
      if(tanaoroshi.inventoryMode != 2 || zoneCode == 0) {
        store.setTanaoroshi(tanaoroshi);
        store.setTanaZoneCode(zoneCode);
        store.setTanaShopCode(tanaoroshi.siteCode)
        router.push({ name: Paths.TANAOROSHI_SAI, params: { id: tanaoroshi.tanaoroshiId } })
      }
    },
    //ソートリセット
    resetCondition(){
      //ソートなし
      this.sortState.target = "";
      this.sortState.ascent = true;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.confirmDialog = {
        actionType: 0,
        tanaoroshi: {},
        shopCode: null,
      };
    },
    async confirmOk(actionType) {
      await this.reload();
      this.closeDialog();
      this.clearActionFormValue();
      
      this.alertFlg = true;
      // 5秒後にアラートを消す
      this.timeoutId = setTimeout(() => {
        this.alertFlg = false;
        this.timeoutId = null;
      }, 5000);
      if(actionType == this.actionButtonKakutei) this.successMsg = this.$t('tanaoroshi.message.successKakutei');
      if(actionType == this.actionButtonRenkei) this.successMsg = this.$t('tanaoroshi.message.successRenkei');
      if(actionType == this.actionButtonDownloadCsv) this.successMsg = this.actionButtonDownloadCsv.label;
      else this.successMsg = "";
      
    },
    confirmCancel() {
      this.closeDialog();
      this.clearActionFormValue();
    },
    showDialog(tanaoroshi, actionType) {
      this.alertFlg = false;
      this.dialogVisible = true;
      this.confirmDialog.actionType = actionType;
      this.confirmDialog.tanaoroshi = tanaoroshi;
      this.confirmDialog.shopCode = tanaoroshi.siteCode;
    },
    tableSort(headValue) {

      if(!(headValue == "shop" || headValue == "num" || headValue == "tanaoroshiId" || headValue == "startDatetime" || headValue == "endDatetime" || headValue == "statusLabel")) return;

      else{
        if(this.sortState.target == headValue){
          this.sortState.ascent = !this.sortState.ascent;
        }
        else{
          this.sortState.target = headValue;
          this.sortState.ascent = true;
        }
      }

    },

    closeZeroDataDialog() {
      this.zeroDataWarningDialogFlg = false;
    },

    // 検索が失敗した。前の結果を残すと今の条件の結果に見えるので、一覧は空にしてエラーを出す
    showSearchError(message, errorList) {
      this.tanaoroshiList = [];
      this.totalCount = 0;
      this.searchErrorDialog = {
        message: message || this.$t("common.message.errorAndRetry"),
        errorList: errorList ?? [],
      };
    },

    changeActionButton(tanaoroshi, tanaoroshiId, actionType) {
      // 選択項目をリセット
      this.currentConfirmId = tanaoroshiId;
      if (actionType == null) return;

      // 棚卸の状態の操作
      if (typeof actionType === "string") {
        this.alertFlg = false;
        this.sessionDialog = { action: actionType, tanaoroshi: tanaoroshi };
        this.sessionDialogVisible = true;
        return;
      }
      this.showDialog(tanaoroshi, actionType);
    },

    clearActionFormValue() {
      const row = this.tanaoroshiList.find(x => x.tanaoroshiId == this.currentConfirmId);
      if (row) row.actionForm = null;
    },

    // 状態ごとに出す操作（要件定義書 第2.1版 BR-09, FR-W-06, FR-W-11, FR-W-12）
    //   実施中: 棚卸終了 / 終了: 終了取消・確定（店舗ユーザーも可。2026-10-23）
    //   確定: 確定解除（管理者だけ。店舗のいちばん新しい棚卸だけ。2026-10-23）
    //   確定以外は、管理者だけ削除（論理削除）もできる
    //   一時中断・再開は 2026-10-26 に廃止した（修正指示書 S-34）。2日目は 終了→翌朝 終了取消 で戻す。
    //   廃止前に一時中断した棚卸が残っていたときだけ、実施中へ戻す「再開」を出す
    filterActionItems(tanaRow) {
      const a = this.sessionActions;
      const csv = tanaRow.canDownloadCsv ? [this.actionButtonDownloadCsv] : [];
      const admin = store.getRole() === constant.ROLE.ADMIN.id;
      const del = admin ? [a.DELETE] : [];
      switch (tanaRow.statusId) {
        case statusId.notEnforcement: return del;
        case statusId.enforcing: return [a.END, ...del];
        case statusId.saved: return [a.RESUME];
        case statusId.ended: return [a.CANCEL_END, a.CONFIRM, ...del];
        case statusId.confirmed:
          return admin && this.isLatestInShop(tanaRow) ? [a.CANCEL_CONFIRM, ...csv] : csv;
        default:
          return csv;
      }
    },

    // 「検索」で反映した条件で、表示中のページを取り直す（ページ送り・操作のあとにも使う）。
    // 絞り込み（店舗・棚卸日・ステータス）・並び順・ページングはサーバーで行う（2026-10-26 修正指示書 S-35・S-31・S-25）
    // showZeroDialog: 0件のときにダイアログを出すか（画面を開いたときの自動表示では出さない）
    async reload(showZeroDialog = true) {
      const cond = this.appliedCondition;
      if (cond == null) return;
      // 「全店舗」または未選択なら、プルダウンの店舗すべて（棚卸日登録・ユーザー登録と同じ。JCIKAIHATSU-496 受入テスト FW-01）。
      // 以前は未選択だと検索せずに 0件にしていた
      const selected = selectedShopCodes(cond.shopCodes, this.shopItem);
      const codes = selected.length > 0 ? selected : this.shopItem.map((e) => e.code);
      if (codes.length === 0) {
        this.tanaoroshiList = [];
        this.totalCount = 0;
        return;
      }
      // 戻ってきたときに同じ条件・同じページで出すため覚えておく
      store.setTanaSearchCondition({ ...cond, page: this.currentPageNo, pageSize: this.displayPerPage.value });
      const body = {
        shopCodeList: codes,
        dateFrom: cond.dateFrom || null,
        dateTo: cond.dateTo || null,
        statusId: cond.statusId ?? null,
        page: this.currentPageNo,
        pageSize: this.displayPerPage.value,
      };
      // 先に投げた検索が後から返ってきても、一覧を上書きしない
      const seq = ++this.searchSeq;
      this.isSearching = true;
      await api.post("/tanaoroshi/search", body)
        .then((response) => {
          if (seq !== this.searchSeq) return;
          if (response.data.status != constant.RESPONSE_STATUS.SUCCESS) {
            this.showSearchError(response.data.errorMessage, response.data.errorList);
            return;
          }
          this.tanaoroshiList = (response.data.results?.tanaoroshiList ?? [])
            .map((t) => ({ ...t, shop: this.shopLabel(t.siteCode) }));
          this.totalCount = response.data.results?.totalCount ?? this.tanaoroshiList.length;
          this.resetCondition();
          // 操作で件数が減って、表示中のページが無くなったら最後のページへ
          if (this.tanaoroshiList.length === 0 && this.currentPageNo > 1 && this.totalCount > 0) {
            this.currentPageNo = this.maxPageNo;
            this.reload(showZeroDialog);
            return;
          }

        // 0件ダイアログ処理
        if(this.tanaoroshiList.length == 0 && showZeroDialog) this.zeroDataWarningDialogFlg = true;
        })
        .catch((error) => {
          if (seq !== this.searchSeq) return;
          this.showSearchError(utils.getErrorMsg(error.response, this.$t));
        });
        if (seq === this.searchSeq) this.isSearching = false;
    },

    //検索ボタンイベント（入力中の条件を反映して1ページ目から）
    async search(event) {
    // 店舗必須チェック
    const validationResult = await event;
      if(!(validationResult.valid)) return;
      this.appliedCondition = { ...this.searchCondition, shopCodes: [...this.searchCondition.shopCodes] };
      this.currentPageNo = 1;
      this.reload(true);
    },

    // 条件を既定（全店舗・当月1日から・指定なし）に戻す。一覧は「検索」を押すまで変えない
    clear() {
      this.searchCondition = { shopCodes: [ALL_SHOPS], dateFrom: firstDayOfThisMonth(), dateTo: "", statusId: null };
    },

    // 店舗リストの取得
    // 自店舗検索リスト取得
    // selectSiteFlag：0：他店舗含む / 1：自店舗のみ
    getValidShopSearchList(){
      api.post("/store/search", {selectSiteFlag: 1})
      .then((response)=>{
        // 店舗が取れないと検索もできないので、失敗を知らせる（それまでは何も出ず「0件」のままだった）
        if (response.data.status != constant.RESPONSE_STATUS.SUCCESS) {
          this.showSearchError(response.data.errorMessage, response.data.errorList);
          return;
        }
        response.data.results?.shopList.forEach(element => {
          this.shopItem.push({name: element.name, code: element.code, code_name: element.code+'_'+element.name}) 
        })
        // 前に見ていた条件・ページ（棚卸結果・参加リーダー一覧から戻ったとき）があればそれを、
        // 無ければ全店舗・当月1日からで出す（2026-10-26 S-20。それまでは先頭の店舗。当月1日は 2026-11-01 S-43）
        const codes = new Set(this.shopItem.map((e) => e.code));
        const last = store.getTanaSearchCondition();
        const lastShops = (last?.shopCodes ?? []).filter((c) => c === ALL_SHOPS || codes.has(c));
        this.searchCondition = {
          shopCodes: lastShops.length > 0 ? lastShops : [ALL_SHOPS],
          // 前の条件が無ければ当月1日から。日付を消して検索していたら消したまま（全期間）にする
          dateFrom: last?.dateFrom ?? firstDayOfThisMonth(),
          dateTo: last?.dateTo ?? "",
          statusId: last?.statusId ?? null,
        };
        const lastSize = this.displayPerPageItem.find((e) => e.value === last?.pageSize);
        if (lastSize) this.displayPerPage = lastSize;
        this.currentPageNo = last?.page > 0 ? last.page : 1;
        this.appliedCondition = { ...this.searchCondition, shopCodes: [...this.searchCondition.shopCodes] };
        // 「検索」を押さなくても一覧を出す（2026-10-23）
        this.reload(false);
      })
      .catch((error) => {
        this.showSearchError(utils.getErrorMsg(error.response, this.$t));
      })
    },

    // 登録ダイアログ表示
    showDialog4Register() {
      this.registerDialogVisible = true;
      this.registerDialog.shopItem = this.shopItem;
    },
    // 登録/更新ダイアログ非表示
    closeRegisterDialog() {
      this.registerDialogVisible = false;
    },
    // 登録/更新ダイアログキャンセル
    confirmRegisterCancel() {
      this.closeRegisterDialog();
    },
    // 登録/更新ダイアログOK押下
    confirmRegisterOk() {
      this.closeRegisterDialog();
    },
    fetchCanDownloadCsvMonthly(settingId){
      api.post("/config/setting", {settingId: "CAN_DOWNLOAD_TANAOROSHI_CSV_MONTHLLY"})
      .then((response)=>{
        if(response.data.status == 1) return; //do nothing
        this.canDownloadCsvMonthly = "1" == response.data.results.settingValue;
      })
      .catch((error) => {
        //do nothing
      })
    },
  },

  unmounted() {
    if(this.timeoutId != null) {
      clearTimeout(this.timeoutId);
      this.alertFlg = false;
    }
  },

  mounted() {
    this.getValidShopSearchList()
    this.fetchCanDownloadCsvMonthly();
  },

};
</script>

<style lang="scss" scoped>
.table_wrap {
  overflow: auto;
  margin: 30px 16px;
  table {
    white-space: nowrap;
    border: solid 1px #bdbdbd;
    width: 100%;
    min-width: 900px;
    border-radius: 10px;
    border-collapse: collapse;
    text-align: center;
    tr {
      &:not(:last-child) {
        border-bottom: 1px solid #eeeeee;
      }
    }
    tbody {
      &:not(:last-child) {
        border-bottom: 1px solid #eeeeee;
      }
    }
    th {
      padding: 8px 6px;
      background-color: #3949ab;
      color: #fff;
    }
  }
  td {
    padding: 6px 6px;
  }
}
/* 操作の名前は「終了取消」「確定解除」など4文字（2026-10-26 S-26）。それまでは「終了取り消し」で 170px */
.action_col {
  min-width: 140px;
}
/* 2行目（店舗名・時刻） */
.cell_sub {
  font-size: 13px;
  color: #555;
}
/* 警告は折り返して、状態の列を広げない */
.status_warn {
  color: #c62828;
  font-size: 12px;
  font-weight: 700;
  white-space: normal;
  max-width: 180px;
  margin: 0 auto;
}
.status_link {
  color: #1565c0;
  text-decoration: underline;
  cursor: pointer;
}
</style>
